module.exports = __webpack_public_path__ + "img/dark-mud-decal-00.e1c4defd.png";